import { ReceiveMessageType, SendMessageType, SubscriptionMessageType } from 'data/types'

import * as AT from './actionTypes'
import { WebSocketWrapper } from './types'

export type SendActionType = {
  payload: SendMessageType
  type: typeof AT.SEND
}

export type SubscribeActionType = {
  payload: SubscriptionMessageType
  type: typeof AT.SUBSCRIBE
}

export type UnsubscribeActionType = {
  payload: {
    readonly message: SubscriptionMessageType
  }
  type: typeof AT.UNSUBSCRIBE
}

export type SocketActionType =
  | SendActionType
  | SubscribeActionType
  | UnsubscribeActionType
  | {
      payload: WebSocketWrapper
      type: typeof AT.SET_CONNECTION
    }
  | { payload: ReceiveMessageType; type: typeof AT.RECEIVED }

const send = (message: SendMessageType): SocketActionType => ({
  payload: message,
  type: AT.SEND
})

const received = (message: ReceiveMessageType) => ({
  payload: message,
  type: AT.RECEIVED
})

const setConnection = (ws: WebSocketWrapper) => ({
  payload: ws,
  type: AT.SET_CONNECTION
})

const subscribe = (message: SubscriptionMessageType): SocketActionType => ({
  payload: message,
  type: AT.SUBSCRIBE
})

const unsubscribe = (message: SubscriptionMessageType): SocketActionType => ({
  payload: { message },
  type: AT.UNSUBSCRIBE
})

export default {
  received,
  send,
  setConnection,
  subscribe,
  unsubscribe
}
